import { $, $all, addClass, removeClass, forEach } from "@olmokit/dom";
import "./Recap.scss";

/**
 * Component: ConfiguratorRecap
 */

export function ConfiguratorRecap() {
  console.log("ConfiguratorMinimal mounted.");
}